export const copyText = async (text: string): Promise<boolean> => {
    try {
        if (text) {
            await navigator.clipboard.writeText(text);
        }
        return true;
    } catch {
        return false;
    }
};

const RICH_TEXT_HTML_TAG_PATTERN = /<(?:p|div|ul|ol|li|blockquote|pre|h[1-6]|hr|br|strong|em|u|s|a|code|span|img)\b/i;

const normalizeTextContent = (text: string) =>
    text
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

const escapeHtml = (text: string) =>
    text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

export const isRichTextHtml = (text: string): boolean => RICH_TEXT_HTML_TAG_PATTERN.test(text);

export const stripHtmlToText = (text: string): string => {
    if (!text) {
        return '';
    }

    if (!isRichTextHtml(text)) {
        return normalizeTextContent(text);
    }

    if (typeof DOMParser !== 'undefined') {
        const parsedDocument = new DOMParser().parseFromString(text, 'text/html');
        return normalizeTextContent(parsedDocument.body.textContent || '');
    }

    return normalizeTextContent(
        text
            .replace(/<[^>]*>/g, ' ')
            .replace(/&nbsp;/gi, ' ')
            .replace(/&amp;/gi, '&')
            .replace(/&lt;/gi, '<')
            .replace(/&gt;/gi, '>')
            .replace(/&quot;/gi, '"')
            .replace(/&#39;/gi, "'"),
    );
};

export const hasVisibleTextContent = (text: string): boolean => stripHtmlToText(text).length > 0;

export const convertPlainTextToHtml = (text: string): string => {
    if (!text) {
        return '';
    }

    if (isRichTextHtml(text)) {
        return text;
    }

    return text
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line.length > 0)
        .map((line) => `<p>${escapeHtml(line)}</p>`)
        .join('');
};
